import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import { Typography, useTheme } from '@mui/material'

import { InputField, CustomCounterAppBar, CustomLoadingOverlay, Buttons, GeoLocationGeneric} from '../../components'
import { documentsActions, fileActions } from '../../store/actions'
import { coreFunctions } from "../../utils";
import { useTranslation } from 'react-i18next';

export default function FirmaClaveComponent(props) {
    const { useState, useEffect, useRef } = React//Hook para el state
    const gridContainer = {} //mainStyles.gridStyle()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)
    // const gridContainer = {} //mainStyles.gridStyle()
    const localStyles = {}//useStyles()//estílos de este componente (LoginStyles.js)
    const navigate = useNavigate()//Módulo "History" de react router

    const [loadView, setLoadView] = useState(false)
    const [txtRazonSocial, setTxtRazonSocial] = useState('')
    const [txtRfc, setTxtRfc] = useState('')
    const [txtPassword, setTxtPassword] = useState('')
    const [activeButton, setActiveButton] = useState(false)

    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [initLoad, setInitLoad] = useState(false)
    const [fileId, setFileId] = useState(0)
    const [singSatRequest, setSingSatRequest] = useState(false)
    const [lat, setLat] = useState("")
    const [lon, setLon] = useState("")
    const [properties, setProperties] = useState([]);
    // const [timeStamp, setTimeStamp] = useState('')

    const { t } = useTranslation();

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const file = useSelector(state => state.FileInfo)
    const digitSingData = useSelector(state => state.DigitSingSATData)

    const dispatch = useDispatch()

    //Promesa general Init
    useEffect(() => {
        let fileId = location.state.folioId
        dispatch(fileActions.GetFileInfo(fileId))
        setInitLoad(true)
        // "dd/MM/yyyy HH:mm:ss",
        // let date = new Date
        // setTimeStamp(`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`)
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && initLoad) {
            let typerazonFindValue = file.items.Metadata?.find(item => item.GroupName == "Datos generales de la empresa / negocio" && item.Name == "Denominación o razón social")

            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)
            setFileId(file.items.Id)
            let razonFindValue = file.items.Metadata?.find(item => item.GroupName == "Datos generales de la empresa / negocio" && item.Name == "Denominación o razón social")
            let rfcFindValue = file.items.Metadata?.find(item => item.GroupName == "Datos generales de la empresa / negocio" && item.Name == "RFC con homoclave")

            setTxtRazonSocial(razonFindValue?.Value)
            setTxtRfc(rfcFindValue?.Value)

            console.log("file.items.Stage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes---------------------: ", file.items.Stage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes)

            setProperties(file.items.Stage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes);



        }
    }, [file])

    useEffect(() => {
        setLoadView(digitSingData.loading)
        if (digitSingData.items != undefined && singSatRequest) {
            console.log("digitSingData-------: ", digitSingData)
            console.log("digitSingData.items---------------------: ", digitSingData.items)
            if (digitSingData.items.Stage != null) {
                let nextStage = digitSingData.items.Stage
                let stageName = nextStage.Name
                let stageId = nextStage.Id
                let folioId = digitSingData.items.Stage?.File?.Id
                let stage = digitSingData.items.Stage

                let nextComponent = coreFunctions.GetLegoNext(stageName)
                coreFunctions.GetLegoNext({ navigate, nextComponent,  State: {stageName, stageId, stage, folioId }})
            }
        } else if (digitSingData.error != undefined && singSatRequest) {
            setSingSatRequest(false)
            console.log("digitSingData---Error----: ", digitSingData.error)
            alert("Ocurrio un error: " + digitSingData.error)
        }
    }, [digitSingData])

    let handleFields = (e) => {//almacenar usuario y contraseña en state
        // console.log("e.target.value: ", e.target.value)
        // console.log("e.target.id: ", e.target.id)
        switch (e.target.name) {
            case 'txtPassword':
                setTxtPassword(e.target.value)
                if (e.target.value != "" && txtRazonSocial != "" && txtRfc != "") {
                    setActiveButton(true)
                } else {
                    setActiveButton(false)
                }
                break;
            case 'txtRazonSocial':
                setTxtRazonSocial(e.target.value)
                if (e.target.value != "" && txtRfc != "" && txtPassword != "") {
                    setActiveButton(true)
                } else {
                    setActiveButton(false)
                }
                break;
            case 'txtRfc':
                setTxtRfc(e.target.value)
                if (e.target.value != "" && txtRazonSocial != "" && txtPassword != "") {
                    setActiveButton(true)
                } else {
                    setActiveButton(false)
                }
                break;
            default:
        }
    }

    let handleFirmar = (e) => {//Login        
        e.preventDefault()

        let documentsArray = [];
        console.log("properties", properties)
        let documentData = file.items.Stage.DocumentalCategory.DocumentalGroups.find(item => item.Name == "Formato autogenerado").DocumentTypes;
        console.log("documentData: ", documentData)

        properties.forEach((it) => {
            let id = it.Id;
            let documentId = documentData.find((i) => i.Id === id).Document?.Id;
            documentsArray.push(documentId);
        });

        console.log("documentsArray: forEach", documentsArray)

        let count = 1;
        documentsArray.forEach((it) => {
            let actualDate = coreFunctions.getActualDateTime();
            let dateSplitted = actualDate.split("|");

            let paramsRequest = {
                ObjectId: it,
                Password: txtPassword,
                TimeStamp: `${dateSplitted[0]} ${dateSplitted[1]}`,
                Latitude: lat,
                Length: lon,
                VideoEvidence: null,
                AudioEvidence: null,
                TextVideoEvidence: null,
                TextAudioEvidence: null,
                AudioEvidenceDate: null,
                VideoEvidenceDate: null,
                TrackingData: {
                    IMEI: "FC:01:7C:45:48:3F",
                    Reference: "reference_" + fileId
                },
                ContinueWorkFlow: count < documentsArray.length ? false : true
            }
            dispatch(documentsActions.DigitalSignSATDocument(paramsRequest))
            console.log("paramsRequest: ", paramsRequest)
            count++;
            setSingSatRequest(true)
        });


        // console.log("validate mayor ---- : ", count > documentsArray.length)
        // if (count > documentsArray.length) {
        //     setSingSatRequest(true)
        //     console.log("Activa la peticion de registro-------")
        // }
    }

    let handleCancel = () => {
        let folioId = fileId
        let nextComponent = "DocumentSignComponent"        
        coreFunctions.GetLegoNext({ navigate, nextComponent,  State: {folioId }})
    }

    //Comienza interfaz
    return (<div className={gridContainer.container}>
        <div className={gridContainer.leftColumn}></div>
        <div className={gridContainer.centerColumn}>
        <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
        console.log("succes,latitude, longitude ", latitude, longitude);
        setLat(latitude);
        setLon(longitude);
      }}
        ErrorFN={(error) => console.log('error', error)}
      />
            {loadView ?
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                : null}
            <CustomCounterAppBar
                initialStep={currentStage}
                endingStep={totalStage} />
            <div className={gridContainer.centerContent1}>
                <div className={localStyles.centerContentInfo} >
                    <div className={localStyles.textContent}>
                        <Typography variant="h6"
                            gutterBottom
                            
          >
                            {t("electronic_signature")}
                        </Typography>
                        <InputField
                            className={localStyles.root}
                            id='txtRazonSocial'
                            name='txtRazonSocial'
                            label='Razón social'
                            variant='outlined'
                            value={txtRazonSocial}
                            required={true}
                            onChange={handleFields}
                            textTransform="none"
                            size="small"
                            type="Text"
                        />
                        <InputField
                            className={localStyles.root}
                            id='txtRfc'
                            name='txtRfc'
                            label='RFC con homoclave'
                            variant='outlined'
                            value={txtRfc}
                            required={true}
                            onChange={handleFields}
                            textTransform="none"
                            size="small"
                            type="Text"
                        />
                        <Typography variant="subtitle1"
                            gutterBottom >
                            {t("enter_private_password")}
                        </Typography>
                        <InputField
                            className={localStyles.root}
                            id='txtPassword'
                            name='txtPassword'
                            label='Contraseña privada'
                            variant='outlined'
                            onChange={handleFields}
                            value={txtPassword}
                            required={true}
                            textTransform="none"
                            size="small"
                            type="Password"
                        />
                    </div>
                </div>
                <Buttons
                    className={activeButton ? localStyles.ButtonActive : localStyles.ButtonDisabled}
                    id='btnFirmar'
                    name='btnFirmar'
                    size={100}
                    background_color={activeButton ? theme.palette.primary.main : '#898B8D'}
                    text_color="#FFFFFF"
                    border_color={activeButton ? theme.palette.primary.main : '#898B8D'}
                    text='Firmar'
                    click={handleFirmar}
                    type='button'
                />
                <Buttons
                    id='btnCancelar'
                    name='btnCancelar'
                    className={localStyles.cancelBtn}
                    size={100} text_color={theme.palette.primary.main}
                    background_color='#ffffff'
                    border_color={theme.palette.primary.main}
                    text={t("general_cancel")}
                    type='button' click={handleCancel} />
            </div>
        </div>
        <div className={gridContainer.rightColumn}></div>
    </div>
    )
}
